import { EFormFieldTypes, TFormField } from '@/interfaces/form'
import BooleanFormField from './boolean'
import BooleanSwitchFormField from './boolean-switch'
import ChecklistFormField from './checklist'
import CurrencyFormField from './currency'
import DateFormField from './date'
import DateTimeFormField from './date-time'
import EnumFormField from './enum'
import EnumMultiFormField from './enum-multi'
import FloatFormField from './float'
import NumberFormField from './number'
import TextFormField from './text'
import UploadFileFormField from './upload-file'
import UploadImageFormField from './upload-image'
import UploadMultipleFormField from './upload-multiple'
import UploadMultipleDragFormField from './upload-multiple-drag'
import VarcharFormField from './varchar'
import { FormState } from '@/state'

export interface TFieldProps {
  fieldInfo: TFormField
  subsectionForm?: boolean
  index: number
}

export default function RenderFormField({
  fieldInfo,
  subsectionForm = false,
  index,
}: TFieldProps) {
  const commonProps = {
    index,
    subsectionForm,
    fieldInfo: {
      ...fieldInfo,
      label: `${index}) ${(fieldInfo.label || fieldInfo.name).replace(/^\d+\)\s*/, '')}`,
    },
  }

  function existEntityDateFieldName(fieldName: string) {
    return FormState.currentEntityDateFields
      .peek()
      .some((item) => item.name === fieldName)
  }

  switch (fieldInfo.type) {
    case EFormFieldTypes.BOOLEAN:
      return <BooleanFormField {...commonProps} />
    case EFormFieldTypes.BOOLEAN_SWITCH:
      return <BooleanSwitchFormField {...commonProps} />
    case EFormFieldTypes.CHECKLIST:
      return <ChecklistFormField {...commonProps} />
    case EFormFieldTypes.CURRENCY:
      return <CurrencyFormField {...commonProps} />
    case EFormFieldTypes.DATE:
      if (!existEntityDateFieldName(fieldInfo.name)) {
        FormState.currentEntityDateFields.value = [
          { name: fieldInfo.name, type: EFormFieldTypes.DATE },
          ...FormState.currentEntityDateFields.peek(),
        ]
      }

      return <DateFormField {...commonProps} />
    case EFormFieldTypes.DATE_TIME:
      if (!existEntityDateFieldName(fieldInfo.name)) {
        FormState.currentEntityDateFields.value = [
          { name: fieldInfo.name, type: EFormFieldTypes.DATE_TIME },
          ...FormState.currentEntityDateFields.peek(),
        ]
      }
      return <DateTimeFormField {...commonProps} />
    case EFormFieldTypes.ENUM:
      return <EnumFormField {...commonProps} />
    case EFormFieldTypes.ENUM_MULTI:
      return <EnumMultiFormField {...commonProps} />
    case EFormFieldTypes.FLOAT:
      return <FloatFormField {...commonProps} />
    case EFormFieldTypes.NUMBER:
    case EFormFieldTypes.INT:
      return <NumberFormField {...commonProps} />
    case EFormFieldTypes.TEXT:
      return <TextFormField {...commonProps} />
    case EFormFieldTypes.UPLOAD_FILE:
      return <UploadFileFormField {...commonProps} />
    case EFormFieldTypes.UPLOAD_IMAGE:
      return <UploadImageFormField {...commonProps} />
    case EFormFieldTypes.UPLOAD_MULTIPLE:
      return <UploadMultipleFormField {...commonProps} />
    case EFormFieldTypes.UPLOAD_MULTIPLE_DRAG:
      return <UploadMultipleDragFormField {...commonProps} />
    case EFormFieldTypes.VARCHAR:
      return <VarcharFormField {...commonProps} />
    default:
      return null
  }
}
